"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _stance = _interopRequireDefault(require("./stance"));
/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line no-unused-vars

_stance.default.install = function (Vue) {
  Vue.component(_stance.default.name, _stance.default);
};
var _default = _stance.default;
exports.default = _default;